import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import OrderColumn from "../../Global/OrderColumn";
import { FaSort } from "react-icons/fa";
import useBulkEnquiry from "./useBulkEnquiry";
import EmptyData from "../../Global/EmptyData";

const BulkEnquiry = () => {

  const { mainData,
    menuState,
    isLoading,
    isFetching,
    handleDateChange,
    handleSearch,
    handleEditClick,
    handleSort,
    getRow,
    currentPage,
    paginationOptions,
    handlePagination,
    handlePageSize,
    showEditModal,
    closeEditModal,
    refetch,
    updateTableFeildsData,
    handleActionChange,
    actionOptions
  } = useBulkEnquiry();
  return (
    <>
      <HeadingGroup
        title={'Bulk Enquiry'}
        className={`pro-mb-4`}

      />



      <div className={`col-auto pro-pt-3 pro-pb-6 `}>
        <div className="row">
          <div className="col">
            <SearchFilters
              data={mainData?.data?.filters}
              onDateChange={handleDateChange}
              onSearchInput={handleSearch}
              showActions={false}
              handleActionClick={handleEditClick}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              actionOptions={actionOptions?.filter((item) => item.value === 0)}
              onActionOptionChange={handleActionChange}
              searchInputProps={{ value: menuState?.search }}

            />
          </div>
        </div>

        {mainData?.data?.data?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            data={mainData?.data?.data || []}
            uniqueID={"id"}
            clear={menuState.clearSelection}
            multiSelect={false}
            assignable={false}
            fields={mainData?.data?.fields}
            SortIcon={<FaSort />}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            perpage={menuState?.currentPageSize}
          />
        )}

        {mainData?.data?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            defaultValue={paginationOptions?.filter(
              (item) => item.value === menuState?.currentPageSize
            )}
            totalPageCount={mainData?.data?.last_page}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}



        <ModalLayout show={showEditModal} handleClose={closeEditModal} backdrop="static">
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={Object.keys(mainData?.data?.fields ?? {})
                .reduce((filteredObj, property) => {
                  filteredObj[property] = mainData?.data?.fields[property];
                  return filteredObj;
                }, {})}
              moduleId={mainData?.data?.module_id}
              updateData={updateTableFeildsData}
            />
          </div>
        </ModalLayout>
      </div>


    </>
  )
}

export default BulkEnquiry
